import styled from 'styled-components';

export const MenuItemContainer = styled.span`
  .tag {
    margin-bottom: 1px;
    font-size: 0.625rem;
    background-color: rgb(200, 46, 41);
    color: rgb(255, 255, 255);
    text-transform: capitalize;
    padding: 1px 0.375rem;
    border-radius: 0.25rem;
  }
`;
